import React from "react";
import { FormattedMessage } from "react-intl";
import starOne from "./icons/char1.webp";
import starTwo from "./icons/char2.webp";
import starThree from "./icons/char3.webp";
import starFour from "./icons/char4.webp";

const style = {
	advWrapper: `mb-12 lg:mb-0 py-4 lg:basis-1/2`,
	titleWrapper: `mb-12`,
	title: `text-lg tracking-wide text-center text-blue lg:text-4xl uppercase aubrey-pro font-bold`,
	advList: `flex flex-col gap-12`,
	adv: `flex items-center text-xl`,
	iconSpan: `text-6xl mr-12`,
	starIcon: `mr-12 w-20 h-20 lg:w-28 lg:h-28`,
	lime: `text-lime`,
	blue: `text-blue`,
	red: `text-red`,
};

const Advantages = () => {
	return (
		<div className={style.advWrapper}>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='title.adv' />
				</h2>
			</div>
			<div className={style.advList}>
				<div className={style.adv}>
					<img src={starOne} alt='char-one' className={style.starIcon} />
					<p>
						<span className={style.lime}>50+</span>{" "}
						<FormattedMessage id='adv-one' />
					</p>
				</div>
				<div className={style.adv}>
					<img src={starTwo} alt='char-two' className={style.starIcon} />
					<p>
						<span className={style.red}>5</span>{" "}
						<FormattedMessage id='adv-two' />
					</p>
				</div>
				<div className={style.adv}>
					<img src={starFour} alt='char-three' className={style.starIcon} />
					<p>
						<span className={style.lime}>PDF</span>{" "}
						<FormattedMessage id='adv-three' />
					</p>
				</div>
				<div className={style.adv}>
					<img src={starThree} alt='char-four' className={style.starIcon} />
					<p>
						<span className={style.red}>21</span>{" "}
						<FormattedMessage id='adv-four' />
					</p>
				</div>
			</div>
		</div>
	);
};

export default Advantages;
